module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.recoursType == 'visa') ? _c('div', [_c('h2', [_vm._v("Apply for a visa for France")]), _vm._v(" "), _c('p', [_vm._v("You did not apply for a visa yet. Our team can help you to build your visa application file and write a cover letter for you")])]) : _c('div', [_c('h2', [_vm._v("You are able to appeal after your visa refusal! ")]), _vm._v(" "), _c('p', [_vm._v("Deadlines are respected, we can help you with your visa appeal file.")])]), _vm._v(" "), _c('p', [_vm._v("You can choose the service that corresponds to your needs")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "justify-content": "space-between",
      "margin": "16px 0px"
    }
  }, [(_vm.recoursType == 'visa') ? _c('md-card', {
    staticClass: "card-layout light-frame"
  }, [_c('md-card-media', {
    staticStyle: {
      "padding": "16px",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "140px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])]), _vm._v(" "), _c('md-card-header', {
    staticStyle: {
      "flex-grow": "2"
    }
  }, [_c('div', {
    staticClass: "md-title",
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "8px"
    }
  }, [_vm._v("Help for your visa application file"), _c('br'), _vm._v("120€")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Help for your visa application that you will have to send by yourself. A 10 minutes questionnaire, cover letter, online procedure, online support.")])]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    on: {
      "click": function($event) {
        return _vm.onClickDetails()
      }
    }
  }, [_vm._v("Details")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        return _vm.onClickSelect('VISA')
      }
    }
  }, [_vm._v("Choose")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.recoursType == 'crrv') ? _c('md-card', {
    staticClass: "card-layout light-frame"
  }, [_c('md-card-media', {
    staticStyle: {
      "padding": "16px",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "140px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])]), _vm._v(" "), _c('md-card-header', {
    staticStyle: {
      "flex-grow": "2"
    }
  }, [_c('div', {
    staticClass: "md-title",
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "8px"
    }
  }, [_vm._v("Board after visa refusal"), _c('br'), _vm._v("299€")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals. 10-minutes questionnaire, online procedure, online support.")])]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    on: {
      "click": function($event) {
        return _vm.onClickDetails()
      }
    }
  }, [_vm._v("Details")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        return _vm.onClickSelect('CRRV')
      }
    }
  }, [_vm._v("Choose")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.recoursType == 'ta') ? _c('md-card', {
    staticClass: "card-layout light-frame"
  }, [_c('md-card-media', {
    staticStyle: {
      "padding": "16px",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "140px"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": "/static/contract.svg"
    }
  })])]), _vm._v(" "), _c('md-card-header', {
    staticStyle: {
      "flex-grow": "2"
    }
  }, [_c('div', {
    staticClass: "md-title",
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "8px"
    }
  }, [_vm._v("Appeal to the Administrative Court Nantes"), _c('br'), _vm._v("299€")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Appeal to the Administrative Court of Nantes.  10-minutes questionnaire, online procedure, online support.")])]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    on: {
      "click": function($event) {
        return _vm.onClickDetails()
      }
    }
  }, [_vm._v("Details")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        return _vm.onClickSelect('TA')
      }
    }
  }, [_vm._v("Choisir")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-card', {
    staticClass: "card-layout light-frame"
  }, [_c('md-card-media', {
    staticStyle: {
      "padding": "16px",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "140px"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": "/static/lawyer.svg"
    }
  })])]), _vm._v(" "), _c('md-card-header', {
    staticStyle: {
      "flex-grow": "2"
    }
  }, [_c('div', {
    staticClass: "md-title",
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "8px"
    }
  }, [_vm._v(" Premium Pack"), _c('br'), _vm._v("999€")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("You are assisted and defended by a specialised lawyer..")])]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    on: {
      "click": function($event) {
        return _vm.onClickDetails()
      }
    }
  }, [_vm._v("Details")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        return _vm.onClickSelect('PREMIUM')
      }
    }
  }, [_vm._v("Choose")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "light-frame",
    staticStyle: {
      "background-color": "#fff",
      "padding": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "align-content": "center",
      "flex-wrap": "wrap"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "32px"
    },
    attrs: {
      "src": "/static/trustedpilot.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('svg', {
    staticClass: "star"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#svg-star"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "star"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#svg-star"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "star"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#svg-star"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "star"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#svg-star"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "star"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#svg-star-half"
    }
  })])]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding-bottom": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "max-width": "200px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/trophy.svg",
      "width": "100%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "cursor": "pointer",
      "padding": "8px 16px",
      "font-size": "1.1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://fr.trustpilot.com/review/getmyvisatofrance.com",
      "target": "_black"
    }
  }, [_vm._v("Consulter les avis clients")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bded13f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Checkout.vue
// module id = 739
// module chunks = 3